module.exports = __webpack_public_path__ + "static/adjustable-base-2-legs-1a90e5fa63c2e0504896cfe7c1ac3526.png";